if (!customElements.get('swk-featured-products-slider')) {
  customElements.define(
    'swk-featured-products-slider',
    class SwkFeaturedProductsSlider extends HTMLElement {
      connectedCallback() {
        this.initSwiper();
      }

      disconnectedCallback() {
        this.destroySwiper();
      }

      initSwiper() {
        if (this.swiper) return;

        const swiperEl = this.querySelector('.swk-featured-products__swiper');
        const paginationEl = this.querySelector('.swk-featured-products__pagination');
        if (!swiperEl) return;

        if (typeof Swiper === 'undefined') {
          window.addEventListener('load', () => this.initSwiper(), { once: true });
          return;
        }

        const isRTL = document.documentElement.getAttribute('dir') === 'rtl';

        this.swiper = new Swiper(swiperEl, {
          slidesPerView: 1.15,
          spaceBetween: 0,
          speed: 600,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          resizeObserver: true,
          ...(isRTL ? { dir: 'rtl' } : {}),
          breakpoints: {
            651: {
              slidesPerView: 2,
            },
            901: {
              slidesPerView: 4,
            },
          },
          pagination: {
            el: paginationEl,
            clickable: true,
            renderBullet(index, className) {
              return `<span class="${className} swk-featured-products__pagination-bar" aria-label="Slide ${index + 1}"></span>`;
            },
          },
        });
      }

      destroySwiper() {
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }
    }
  );
}
